import { getManualByKey } from '@/http/manualApi'

export class ManualService {
  async setManualByKey({ isAuth, key }) {
    const { data } = await getManualByKey({ isAuth, key })
    return data
  }
}
